import { useState } from 'react'
import { HicDataGridPro } from 'src/app/components/hic-vapor/datagrid/datagrid'
import { RowRRProductionDetail } from './productions.types'
import { keysOf } from 'src/utils/utils'
import { GridColDef } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import useFormatCurrency from 'src/app/hooks/current-locale/use-format-currency'
import { Link } from '@vapor/material'
import { ReservationDetailDrawer } from '../../../../reservation-detail-wrapper'
import PosDrawer from 'src/app/pages/booking/pos/pos-drawer'
import { ReservationHeaderTab } from '../../../../types/reservation-detail.types'

type MovedProductionsGridProps = {
  propertyId: string
  rows: RowRRProductionDetail[]
}

export const MovedProductionsGrid = (props: MovedProductionsGridProps) => {
  const { t } = useTranslation()
  const formatDate = useFormatDate()
  const { formatCurrency } = useFormatCurrency()

  const [selectedReservation, setSelectedReservation] = useState<string>()
  const [selectedBillId, setSelectedBillId] = useState<string>()

  const f = keysOf<RowRRProductionDetail>()

  const columns: GridColDef<RowRRProductionDetail>[] = [
    {
      field: f('date'),
      headerName: t('pms.booking.reservation.productions_assigned.date'),
      flex: 1,
      minWidth: 80,
      maxWidth: 150,
      resizable: false,
      disableColumnMenu: true,
      type: 'Date',
      renderCell: (params) => {
        return formatDate(params.value)
      },
    },
    {
      field: f('chargeCategoryName'),
      headerName: t('pms.booking.reservation.productions_assigned.charge_category'),
      flex: 1,
      minWidth: 100,
      maxWidth: 150,
      disableColumnMenu: true,
    },
    // {
    //   field: f('description'),
    //   headerName: t('pms.booking.reservation.productions_assigned.description'),
    //   flex: 1,
    //   disableColumnMenu: true,
    // },
    {
      field: f('amount'),
      headerName: t('pms.booking.reservation.productions_assigned.amount'),
      flex: 1,
      minWidth: 80,
      maxWidth: 150,
      disableColumnMenu: true,
      align: 'right',
      headerAlign: 'right',
      type: 'number',
      renderCell: (params) => {
        const row = params.row as RowRRProductionDetail
        const value = formatCurrency(row.amount, row.currency)
        return value
      },
    },
    {
      field: f('quantity'),
      headerName: t('pms.booking.reservation.productions_assigned.quantity'),
      width: 50,
      disableColumnMenu: true,
      align: 'right',
      headerAlign: 'right',
      type: 'number',
    },
    {
      field: f('total'),
      headerName: t('pms.booking.reservation.productions_assigned.total'),
      flex: 1,
      minWidth: 80,
      maxWidth: 150,
      disableColumnMenu: true,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => {
        const row = params.row as RowRRProductionDetail
        return formatCurrency(row.total, row.currency)
      },
    },
    {
      field: 'destination',
      headerName: 'Destinazione',
      minWidth: 120,
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        const row = params.row as RowRRProductionDetail
        if (row.reservationCode && row.reservationId) {
          return (
            <Link
              onClick={() => {
                setSelectedReservation(row.reservationId)
              }}
            >
              {row.reservationCode}
            </Link>
          )
        } else {
          return (
            <Link
              onClick={() => {
                setSelectedBillId(row.billId)
              }}
            >
              {row.billDescription}
            </Link>
          )
        }
      },
    },
  ]

  return (
    <>
      <HicDataGridPro rows={props.rows} columns={columns} rowHeight={30} hideFooter />
      <ReservationDetailDrawer
        propertyId={props.propertyId}
        open={Boolean(selectedReservation)}
        reservationId={selectedReservation}
        onClose={() => {
          setSelectedReservation(undefined)
        }}
        reservationTabIndex={ReservationHeaderTab.BILLS}
      />
      <PosDrawer
        propertyId={props.propertyId}
        billId={selectedBillId}
        closeDrawer={() => {
          setSelectedBillId(undefined)
          // TODO check refresh bills
        }}
      />
    </>
  )
}
